<template>
	<dashboard-dropdown-section
		title="Availabilities Set"
		type="locum-availabilities-set"
		:items-shown="5"
		:items="availabilities"
		event-name="load-locum-availabilities-set"
		@load-locum-availabilities-set="loadMore"
	/>
</template>

<script>
import { mapActions } from 'vuex';

import DashboardDropdownSection from '@/components/custom/DashboardDropdownSection';

export default {
	name: 'LocumAvailabilities',

	components: { DashboardDropdownSection },

	data: () => ({
		availabilities: [],
	}),

	methods: {
		...mapActions('availability', ['FetchProfessionalAvailability']),

		async loadMore(event) {
			const { startDate, endDate } = event;

			const availabilityResults = await this.FetchProfessionalAvailability({ startDate, endDate, availabilityType: 'availabilities' });
			this.availabilities = availabilityResults.map(availability => ({ ...availability, event_start_date: availability.date }));
		},
	},
};
</script>
